import { ApplicationConfig } from '@angular/core';

import { PhonePipe } from '../pipes/phone.pipe';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';

export const pipesProvider: ApplicationConfig['providers'] = [PhonePipe, SafeHtmlPipe];
